import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { I18n } from 'react-redux-i18n';
import { SiteValidations } from '../../../models';

import Button from '../../inputs/button/Button';
import AddForm from '../addform/AddForm';
import FormActions from '../formactions/FormActions';
import FormField from '../formfield/FormField';

export class AddSiteForm extends Component {
  render() {
    return (
      <AddForm onSubmit={this.props.handleSubmit}>
        <Field
          name="name"
          label={I18n.t('models.site.name')}
          type="text"
          placeholder={I18n.t('models.site.name')}
          component={FormField}
          maxLength="24"
          validate={SiteValidations.name}
          initialValues={this.props.initialValues}
        />
        <FormActions>
          <Button>
            {I18n.t(this.props.isEditing ? 'edit.save' : 'add.add')}
          </Button>
        </FormActions>
      </AddForm>
    );
  }
}

export default reduxForm({
  form: 'addsite'
})(AddSiteForm);



// WEBPACK FOOTER //
// ./src/components/forms/addsiteform/AddSiteForm.js